import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SlotElement from "./SlotElement";

const ManualSlotting = () => {
  const { id } = useParams();
  const [participants, setParticipants] = useState([]);
  const [givenSlot, setGivenSlot] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [competition, setCompetition] = useState({});
  const navigate = useNavigate();

  const [slot, setSlot] = useState({ id: "", slotNumber: 0 });

  const fetchCompiDetails = () => {
    Axios.get(`https://ashish.moodi.org/multicity/get_compi_details?id=${id}`)
      .then((res) => setCompetition(res.data))
      .catch((err) => console.error(err));
  };

  const getParticipants = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_mul_participants_slot?id=${id}`
    )
      .then((res) => setParticipants(res.data))
      .catch((err) => console.error(err));
  };

  const fetchSlottedParticipants = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_mul_participants?id=${id}`
    )
      .then((res) => setGivenSlot(res.data))
      .catch((err) => console.error(err));
  };

  const onSubmitClick = () => {
    setDisabled(true);
    if (competition.isTeamCompi) {
      Axios.post(
        "https://ashish.moodi.org/multicity/mul_manual_slot",
        {
          id: slot.id,
          slotNumber: slot.slotNumber,
          competition: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            window.alert("Slot given successfully!");
            window.location.reload();
          }
        })
        .catch((err) => console.error(err));
    } else {
      Axios.post(
        "https://ashish.moodi.org/multicity/mul_manual_slot",
        {
          id: slot.id,
          slotNumber: slot.slotNumber,
          competition: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            window.alert("Slot given successfully");
            window.location.reload();
            // setDisabled(false);
            // setSlot({ mrcId: "", slotNumber: 0 });
            // setGivenSlot((current) => [...current, res.data.slot]);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const onChange = (e) => {
    setSlot({ ...slot, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      getParticipants();
      fetchSlottedParticipants();
      fetchCompiDetails();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <h2>{competition.mcName} - Slotting</h2>
      <div className="row">
        <select name="id" id="id" className="col-sm-2" onChange={onChange}>
          <option value="">Select MI Number</option>
          {participants.map((participant) => {
            if (
              givenSlot.find(
                (element) =>
                  element.userTeamId === participant.mrcId ||
                  element.userTeamId === participant.mcTeamId
              )
            ) {
              return <></>;
            } else {
              return (
                <option
                  value={
                    competition.isTeamCompi
                      ? participant.mcTeamId
                      : participant.mrcId
                  }
                >
                  {participant.MI_NO}
                </option>
              );
            }
          })}
        </select>
        <div className="col-sm-1"></div>
        <select
          name="slotNumber"
          id="slotNumber"
          className="col-sm-3"
          onChange={onChange}
        >
          <option value={0}>Select Slot Number</option>
          {participants.map((participant, index) => {
            if (givenSlot.find((element) => element.slotNumber === index + 1)) {
              return <></>;
            } else {
              return <option value={index + 1}>Slot - {index + 1}</option>;
            }
          })}
        </select>
        <div className="col-sm-1"></div>
        {disabled ? (
          <button
            class="btn btn-primary col-auto"
            type="submit"
            disabled={disabled}
          >
            <span
              class="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
            <span role="status">Submitting</span>
          </button>
        ) : (
          <input
            type="submit"
            value="Submit"
            className="btn btn-primary col-auto"
            disabled={disabled}
            onClick={onSubmitClick}
          />
        )}
      </div>
      <h2 className="my-3">Slotted Participants</h2>
      <hr />
      <div className="row">
        <h5 className="col-sm-2">MI Number</h5>
        <div className="col-sm-1"></div>
        <h5 className="col-sm-2">Slot Number</h5>
        <h5 className="col-sm-3">Phone Number</h5>
      </div>
      <hr />
      <hr />
      {givenSlot.map((slot) => {
        return (
          <SlotElement
            slot={slot}
            competition={competition}
            participants={participants}
          />
        );
      })}
    </div>
  );
};

export default ManualSlotting;
